import { TemplateResolver } from "../templates/TemplateResolver";
import { TemplateFactory } from "../templates/TemplateFactory";
export class BaseAction {
    constructor(action) {
        this.action = action;
    }
    renderTemplate() {
        const templateType = TemplateResolver.resolve(this.action);
        const template = TemplateFactory.create(templateType, this.action);
        template.render();
    }
}
